export const elperdón = {
	nombre: "El Perdón",
	dia: "Viernes Santo",
	nombrecompleto:
		"Venerable Cofradía de Penitencia del Santísimo Cristo del Perdón y María Santísima del Rosario en sus Misterios Dolorosos",
	sede: "Parroquia de Santa Cruz",
	pasos: 2,
	distancia: [1120, 2070],
	penitentes: 220,
	cargadores: 120,
	web: "http://www.diariodecadiz.es/semana_santa/Perdon_0_1229577732.html",

	ida: [
		{ lng: -6.294476, lat: 36.5285778 },
		{ lng: -6.2944291, lat: 36.5286435 },
		{ lng: -6.2945444, lat: 36.5287049 },
		{ lng: -6.294883, lat: 36.5281769 },
		{ lng: -6.295917, lat: 36.5286441 },
		{ lng: -6.2956434, lat: 36.5293294 },
		{ lng: -6.2955067, lat: 36.5295881 },
		{ lng: -6.2946296, lat: 36.529407 },
		{ lng: -6.2943533, lat: 36.5305515 },
		{ lng: -6.2941012, lat: 36.5305709 },
		{ lng: -6.2935057, lat: 36.5307347 },
		{ lng: -6.292921, lat: 36.5310774 },
		{ lng: -6.2922022, lat: 36.5302691 },
		{ lng: -6.2928298, lat: 36.5297928 },
		{ lng: -6.2930498, lat: 36.5298101 },
		{ lng: -6.293259, lat: 36.5297389 },
		{ lng: -6.2945169, lat: 36.5296355 },
		{ lng: -6.2946403, lat: 36.5295493 },
		{ lng: -6.2950453, lat: 36.5296247 },
		// CATEDRAL
		{ lng: -6.29535, lat: 36.52899 }
	],
	vuelta: [
		{ lng: -6.29535, lat: 36.52899 },
		{ lng: -6.2956998, lat: 36.5291031 },
		{ lng: -6.2954101, lat: 36.5297497 },
		{ lng: -6.2956622, lat: 36.5299588 },
		{ lng: -6.295284, lat: 36.5303403 },
		{ lng: -6.2950104, lat: 36.5308424 },
		{ lng: -6.2949193, lat: 36.5308468 },
		{ lng: -6.29493, lat: 36.5314588 },
		{ lng: -6.2964749, lat: 36.5317821 },
		{ lng: -6.2964106, lat: 36.531864 },
		{ lng: -6.2965634, lat: 36.5321313 },
		{ lng: -6.2969939, lat: 36.5328694 },
		{ lng: -6.2971227, lat: 36.533044 },
		{ lng: -6.2984678, lat: 36.5343457 },
		{ lng: -6.2977074, lat: 36.5350612 },
		{ lng: -6.2966962, lat: 36.5346798 },
		{ lng: -6.2963314, lat: 36.5343091 },
		{ lng: -6.2960149, lat: 36.5339718 },
		{ lng: -6.2954483, lat: 36.5340138 },
		{ lng: -6.2921754, lat: 36.5302605 },
		{ lng: -6.2928177, lat: 36.5297745 },
		{ lng: -6.2930471, lat: 36.5297961 },
		{ lng: -6.2932563, lat: 36.5297217 },
		{ lng: -6.2933381, lat: 36.5297163 },
		{ lng: -6.2933877, lat: 36.5294124 },
		{ lng: -6.2932348, lat: 36.5293909 },
		{ lng: -6.2932898, lat: 36.5291344 },
		{ lng: -6.2938222, lat: 36.5292023 },
		{ lng: -6.2938423, lat: 36.5291495 },
		{ lng: -6.2941079, lat: 36.5291656 },
		{ lng: -6.2942105, lat: 36.5288154 },
		{ lng: -6.2942655, lat: 36.5285724 },
		{ lng: -6.2944197, lat: 36.5286451 },
		{ lng: -6.2944713, lat: 36.5285762 }
		// ...
	],
	markers: [
		{
			name: "Salida",
			hora: "2018-03-30T00:10",
			latlng: [36.52857, -6.29447]
		},
		{
			name: "Nueva",
			hora: "2018-03-30T02:00",
			latlng: [36.53062, -6.29249]
		},
		{
			name: "Catedral",
			hora: "2018-03-30T03:00",
			latlng: [36.52899, -6.29535]
		},
		{
			name: "Candelaria",
			hora: "2018-03-30T04:00",
			latlng: [36.53106, -6.295]
		},
		{
			name: "Palillero",
			hora: "2018-03-30T04:25",
			latlng: [36.53196, -6.2965]
		},
		{
			name: "Valverde Barrié",
			hora: "2018-03-30T04:35",
			latlng: [36.53254, -6.29679]
		}
	],
	itinerario: [
		[
			"Jesús de Medinaceli",
			"Stmo. Cristo del Perdón",
			"Campo del Sur",
			"Arquitecto Acero",
			"Plaza Pio XII",
			"Cobos",
			"Cristóbal Colon",
			"Nueva"
		],
		[
			"Plaza San Juan de Dios",
			"Pelota",
			"Plaza Pio XII",
			"Estación de Penitencia en la S.I.C."
		],
		[
			"Arquitecto Acero",
			"Plaza de Pío XII",
			"Compañía",
			"Santiago",
			"Plaza Candelaria"
		],
		["Montañes", "Palillero"],
		["Novena", "Ancha"],
		[
			"San José Drcha.",
			"Plaza Mina",
			"Tinte",
			"Plaza San Francisco",
			"Rosario Izda.",
			"Beato Diego",
			"San Francisco",
			"Plaza San Agustín",
			"San Francisco",
			"Nueva",
			"Plaza San Juan de Dios",
			"Pomponio Mela",
			"Fabio Rufino",
			"San Antonio Abad",
			"Posadilla",
			"Plaza de San Martín",
			"Obispo José María Rancés",
			"Plaza de Fray Félix",
			"Jesus de Medinaceli"
		]
	],
	mapConfig: {
		center: [36.5311, -6.29721],
		zoom: 17
	}
};



// WEBPACK FOOTER //
// ./src/data/procesiones/elperdón.js